import React from 'react'
import ImageDisplayTest from '../components/test/ImageDisplayTest'

const ImageDisplayTestPage: React.FC = () => {
  return <ImageDisplayTest />
}

export default ImageDisplayTestPage